<template>
  <v-container fluid class="stores-container" @keyup.enter="connect">
    <v-row no-gutters justify="center">
      <v-col cols="5" class="stores-container__content">
        <v-row no-gutters justify="center">
          <v-col cols="4" class="mb-10 d-flex justify-center">
            <!-- <router-link :to="`/${lang}/`"     >
                            <img
                                src="@/assets/home/logo-sticky.png"
                                width="160"
                                style="vertical-align: middle"
                            />
                        </router-link> -->
            <v-list-item
              href="https://www.roadcube.com"
              class="d-flex justify-center align-center rounded-lg"
              style="max-width: 200px"
            >
              <img src="@/assets/home/logo-sticky.png" width="160" style="vertical-align: middle"
            /></v-list-item>
          </v-col>

          <v-col cols="12">
            <v-card outlined class="stores-container__card">
              <v-row no-gutters justify="center">
                <v-col cols="12" class="text-center mt-4">
                  <v-icon
                    color="black"
                    v-text="icons.mdiAccount"
                    size="100"
                    class="card__account-icon"
                  ></v-icon>
                </v-col>
                <v-col cols="12" class="text-center mt-4">
                  <h1 class="text-h6 font-weight-black pl-0">
                    <span class="pl-8">{{ `${$store.state.user.full_name}` }}</span>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="darken-3"
                          class="mb-2"
                          icon
                          size="26"
                          v-on="on"
                          @click="openNameDialog"
                        >
                          <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                      </template>

                      <span class="font-weight-bold">{{
                        translations.changeProfileName[lang]
                      }}</span>
                    </v-tooltip>
                  </h1>
                </v-col>

                <v-card-subtitle class="font-weight-bold black--text pl-0 pt-6 pb-0">
                  {{ translations.cardDescription[lang] }}
                </v-card-subtitle>

                <v-col cols="12" class="d-flex justify-center">
                  <v-col cols="8">
                    <UserStoresSelect v-model="store" :loading="loading" />
                  </v-col>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn :disabled="disabled" :loading="loading" @click="connect" class="card__btn">
                    {{ translations.enter[lang] }}
                  </v-btn>
                </v-col>
                <v-col cols="12" class="d-flex justify-center mt-4">
                  <span class="logout-link" @click="logout">
                    {{ translations.logout[lang] }}
                  </span>
                </v-col>
              </v-row>
            </v-card>

            <v-col cols="12" class="d-flex justify-center mt-6">
              <span class="ml-1 store-link" @click="createNewCompany()">{{
                translations.createCompany[lang]
              }}</span>
            </v-col>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="nameDialog" max-width="500">
      <b-card
        :title="translations.changeProfileName[lang]"
        @cancel="closeNameDialog()"
        @submit="changeProfileName()"
        :submit-text="translations.save"
        :cancel-text="translations.cancel"
        :loading="loading"
      >
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <b-text-field :label="translations.fullName[lang]" v-model="newName"></b-text-field>
          </v-col>
        </v-row>
      </b-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mdiArrowRight, mdiMenuUp, mdiMenuDown, mdiAccount, mdiPencilOutline } from '@mdi/js';
import { mapActions, mapMutations, mapState } from 'vuex';
import UserStoresSelect from '@/components/general/UserStoresSelect.vue';
import API from '@/models/API';
import translations from '@/utils/translations/userStores';

export default {
  name: 'UserStores',

  mixins: [translations],

  components: { UserStoresSelect },

  data() {
    return {
      icons: {
        mdiArrowRight,
        mdiMenuUp,
        mdiMenuDown,
        mdiAccount,
        mdiPencilOutline,
      },
      disabled: true,
      errorMessage: '',
      store: null,
      success: false,
      closeMenu: false,
      rules: [
        (v) => {
          if (v) {
            this.success = true;
            return true;
          } else {
            return 'Store is required';
          }
        },
      ],
      menu: false,
      nameDialog: false,
      newName: '',
    };
  },

  computed: {
    ...mapState(['accessToken', 'userStores', 'loading', 'user']),

    lang() {
      return this.$route.params.lang;
    },
  },

  methods: {
    ...mapMutations(['setUserStores', 'setStoreId', 'setAccessToken', 'setLoading']),
    ...mapActions(['getUser', 'getUserStores', 'updateProfileName']),
    ...mapActions('storePanel', ['getStore']),
    ...mapActions('loyaltyPanel', ['getCompany']),

    async connect() {
      try {
        this.setLoading(true);
        localStorage.setItem('storeId', this.store.store_id);
        this.setStoreId(this.store.store_id);
        await this.getUser(this.store.store_id);
        if (this.store.store_type_id === 1) {
          await this.getCompany();
          this.$router.push(`/${this.lang}/loyaltyPanel`);
        } else if (this.store.store_type_id === 2) {
          await this.getStore();
          this.$router.push(`/${this.lang}/storePanel`);
        } else if (this.store.store_type_id === 3) {
          this.$router.push(`/${this.lang}/supplierPanel/send-reports/pending`);
        }
        this.setLoading(false);
      } catch (ex) {
        this.setLoading(false);

        this.errorMessage = ex.response.data.message;
        setTimeout(() => (this.errorMessage = ''), 5000);
      }
    },

    createNewStore() {
      localStorage.setItem('showUserDetails', false);
      localStorage.setItem('registerPage', 2);
      this.$router.push(`/${this.lang}/app-providers`);
    },

    createNewCompany() {
      localStorage.setItem('showUserDetails', false);
      localStorage.setItem('registerPage', 1);
      this.$router.push(`/${this.lang}/subscription-plans`);
    },

    async logout() {
      try {
        const { data } = await API.post(`/users/logout`);

        localStorage.removeItem('storeId');
        localStorage.removeItem('companyId');
        localStorage.removeItem('accessToken');
        this.setAccessToken('');
        this.$router.push(`/${this.lang}/sign-in`);
      } catch (ex) {
        console.log(ex.response.data);
      }
    },

    openNameDialog() {
      this.newName = '' + this.user.full_name;
      this.nameDialog = true;
    },

    closeNameDialog() {
      this.newName = '';
      this.nameDialog = false;
    },
    async changeProfileName() {
      let res = await this.updateProfileName({
        full_name: this.newName,
      });
      if (res.status == 200) {
        this.closeNameDialog();
      }
    },
  },

  async mounted() {
    if (!this.userStores.length) {
      await this.getUserStores();
    }
    if (!this.userStores.length) {
      this.$router.push(`/${this.lang}/subscription-plans`);
    }
  },

  watch: {
    store(val) {
      if (val) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },
};
</script>
<style lang="scss">
.stores-container {
  height: 100%;
  padding: 0;
  background-color: #f5f5fd;
  font-family: 'Roboto', sans-serif;

  .stores-container__content {
    margin-top: 6%;

    .stores-container__card {
      padding: 20px 100px;
    }
  }

  .card__account-icon {
    border: 1px solid black;
    border-radius: 100%;
    padding: 5px;
  }

  .card__btn {
    background-color: #2255fe !important;
    color: #f5f5fd !important;
    padding: 20px 40px !important;
    text-transform: inherit !important;
    letter-spacing: 1.5px;
  }

  .logout-link {
    text-decoration: underline;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .store-link {
    text-decoration: underline;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
}
</style>
